import type { ConfigurableServer } from '@festina-life/core'
import { useTranslate } from '@festina-life/ui/hooks'

import { ManageSection } from '../manageSection/ManageSection'
import { CreateServerBranchButton } from './CreateServerBranchButton'

type Props = {
  server: ConfigurableServer
}

export const ManageServer = ({ server }: Props) => {
  const translate = useTranslate()

  return (
    <div className="flex flex-col gap-y-4 p-1">
      <ManageSection
        title={translate('serverDetailsPanel.tabs.manage.section.common.title')}
        options={[
          {
            label: translate('serverDetailsPanel.tabs.manage.createBranch'),
            description: translate(
              'serverDetailsPanel.tabs.manage.section.common.help.createBranch',
            ),
            button: <CreateServerBranchButton server={server} />,
          },
        ]}
      />
    </div>
  )
}
